import Modal from "components/atom/Modal.tsx";
import {useEffect, useState} from "react";
import {useAppSelector} from "config/store";
import Button from "components/atom/button/Button.tsx";
import designerPng from 'assets/images/designer.png'
import {UserType} from "globals/types/models.ts"
import {useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {STORAGE_WELCOME_MODAL_KEY} from "utils/data/global.ts";
import { USER_TYPES } from "globals/constants.ts";


function WelcomeAutomaticModal() {
    const currentUser: UserType | null = useAppSelector(state => state.auth.user)
    const location = useLocation()
    const{t} = useTranslation()

    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        if (!currentUser) {
            setIsOpen(false)//make sure its not showed
            return
        }

        //must be in admin panel
        if (location.pathname !== '/profile') {
            setIsOpen(false)//make sure its not showed
            return
        }

        //dont show for viewer
        if (currentUser.type === USER_TYPES.VIEWER){
            setIsOpen(false)//make sure its not showed
            return
        }

        //max 3 login before this disappear
        if (currentUser.loginCount >= 1) {
            setIsOpen(false)//make sure its not showed
            return
        }

        const hasBeenShowed = localStorage.getItem(STORAGE_WELCOME_MODAL_KEY) === 'true'

        if (hasBeenShowed) {
            return
        }

        localStorage.setItem(STORAGE_WELCOME_MODAL_KEY, 'true')

        setIsOpen(true)
    }, [location.pathname, currentUser])

    if (!isOpen) {
        return null
    }

    return (
        <Modal flexibleHeight className="-welcome" onClose={() => setIsOpen(false)}>
            <div className="w-full">
                <img src={designerPng} className="mx-auto block h-[200px] w-auto"/>
                <h2 className="pb-3 text-center text-2xl font-bold text-green-500">
                    {t('popup.welcome.title')}<br/>
                    <span className="text-xl">{t('popup.welcome.title2')}</span>
                </h2>
                <p className="pb-12 text-center text-gray-400" dangerouslySetInnerHTML={{
                    __html: t('popup.welcome.description')
                }} />

                <Button className="block w-full" onClick={() => setIsOpen(false)}>
                    {t('popup.welcome.start')}
                </Button>

            </div>
        </Modal>
    )
}


export default WelcomeAutomaticModal
